import { SliceStatusResult, SliceStatusResultExtentions } from "../models/sliceStatusResult";

const errorCodeTranslations: { [key: string]: string} = {
    PCS101: 'O voucher escolhido esgotou.',
    LOCAL01: 'Erro Inesperado. Por favor, tente novamente mais tarde.',
    LOCAL02: 'Não foram encontrados comerciantes. Por favor, tente novamente mais tarde.'
};

export const translateErrorCode = (code: string) : SliceStatusResult => {
    const translation: string = errorCodeTranslations[code] || errorCodeTranslations.LOCAL01;
    return SliceStatusResultExtentions.failed(code, translation);
}

export const canTranslateErrorCode = (code: string): boolean => !!errorCodeTranslations[code];